import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    deleted: {}
  },
  getters: {
    deleted: state => state.deleted
  },
  mutations: {
    setDeleted (state, payload) {
      state.deleted = payload
    }
  },
  actions: {
    async del ({ commit }, id) {
      const response = await new ApiService(id).del()
      commit('setDeleted', response)
    }
  }
}
